import { Check, Copy } from 'lucide-react';
import { Button } from '../components/Button';
import { useCopy } from './useCopy';

export function ReferralShareControls({ referralUrl, referralCode, code }: {
  referralUrl: string; referralCode?: string; code: string;
}) {
  const linkCopy = useCopy(code);
  const codeCopy = useCopy(code);
  return (
    <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
      <input aria-label="Your referral link" readOnly value={referralUrl}
        onFocus={event => event.currentTarget.select()}
        onClick={event => event.currentTarget.select()}
        className={`min-w-0 flex-1 rounded-lg border border-border bg-card px-3 py-2 font-mono text-xs ${linkCopy.failed ? '' : 'hidden lg:block'}`} />
      <Button size="sm" onClick={() => linkCopy.copy(referralUrl)} aria-live="polite">
        {linkCopy.copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
        {linkCopy.copied ? 'Link copied' : 'Copy link'}
      </Button>
      {referralCode && <div className="flex min-w-0 items-center gap-2">
        <input aria-label="Your referral code" readOnly value={referralCode.toUpperCase()}
          onFocus={event => event.currentTarget.select()}
          onClick={event => event.currentTarget.select()}
          className="w-28 min-w-0 rounded-lg border border-border bg-card px-2 py-2 font-mono text-xs" />
        <Button size="sm" variant="outline" onClick={() => codeCopy.copy(referralCode.toUpperCase())} aria-live="polite">
          {codeCopy.copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          {codeCopy.copied ? 'Code copied' : 'Copy code'}
        </Button>
      </div>}
      {(linkCopy.failed || codeCopy.failed) && <span role="alert" className="w-full text-xs text-destructive">
        Copy failed. Select the {codeCopy.failed ? 'code' : 'link'} instead.
      </span>}
    </div>
  );
}
